import { createFileRoute } from '@tanstack/react-router';
import { ProjectOverview } from '@/features/projects/project-overview';

export const Route = createFileRoute('/_app/p/$projectKey/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { projectKey } = Route.useParams();
  return <ProjectOverview projectKey={projectKey} />;
}
